export default __webpack_public_path__ + "static/media/scdream9.9aa76886.woff";